<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- foto, nome e função -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <!-- foto -->
          <img
            class="w-10 h-10 rounded-full"
            :src="!row['avatar'] ? defaultImg : row['avatar']"
            :alt="'Foto de ' + row['name']"
          />

          <!-- nome e função -->
          <div class="ps-3">
            <!-- <div class="text-base font-semibold">
              {{
                row["name"].length > 20
                ? row["name"].slice(0, 20).concat('...')
                : row["name"]
              }}
            </div> -->
            <div>
              <div title="email" class="text-base text-gray-900">
                {{
                  row["name"].length > 20
                    ? row["name"].slice(0, 20).concat("...")
                    : row["name"]
                }}
              </div>

              <div v-if="row['students_count']" class="font-normal text-gray-500 lowercase">
                Alunos: <span class="text-green-500 font-semibold"> {{ row["students_count"] }} </span>
              </div>
            </div>
          </div>
        </th>

        <!-- cell e email -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <div title="email" class="text-base text-gray-900">
              {{
                row["companies"]?.name.length > 15
                  ? row["companies"]?.name.slice(0, 15).concat("...")
                  : row["companies"]?.name ?? "não informado"
              }}
            </div>

            <div class="font-normal text-gray-500 lowercase">
              {{
                row["companies"]?.CNPJ.length > 20
                  ? row["companies"]?.CNPJ.slice(0, 20).concat("...")
                  : row["companies"]?.CNPJ ?? "não informado"
              }}
            </div>
          </div>
        </td>

        <!-- participações em eventos -->
        <td class="px-1 py-4 text-center">
          <div
            class=""
          >
            {{ row["trainings_count"] }}
          </div>
        </td>

        <!-- ações -->
        <td class="px-6 py-4">
          <div class="flex justify-center font-medium">
            <!-- Drawer -->
            <a
              title="Detalhes da turma"
              class="text-green-600 mr-1 cursor-pointer"
              @click="openModal(data[index])"
            >
              <component :is="PhFileText" class="h-7 w-7 md:h-6 md:w-6" />
            </a>

            <!-- editar -->
            <router-link
              title="Alterar grupo"
              class="text-yellow-600 mr-1 hover:underline cursor-pointer"
              :to="'/group/edit/' + row['id']"
            >
              <component :is="PhNotePencil" class="h-6 w-6" />
            </router-link>

            <a
              :title="'Desativar turma'"
              @click="desactiveGroup(row['id'])"
              class="text-red-600 ml-1 hover:underline cursor-pointer"
            >
              <component :is="PhTrash" class="h-6 w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import collabService, { PATH } from '../services/collab.service'
import moment from 'moment'
import { PhFileText, PhNotePencil, PhTrash } from '@phosphor-icons/vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { defineProps, ref } from 'vue'
import { storeApp } from '@/store'
import { dataFighters } from '../store'
import { dataGroups } from '../store/groups'
import { PdfCreate } from '@/utils/reports/generate-blob'
import ReportModal from '@/components/Modals/Reports.vue'
import Create from '@/components/Buttons/Create.vue'
import Preview from './Report/Preview.vue'
import groupService from '../services/group.service'

const imageServe = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const defaultImg = require('@/assets/logo/icon.png')

const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

async function desactiveGroup (id) {
  storeApp.state.loading = true
  const confirm = window.confirm('Deseja desativar esse grupo?')
  if (confirm) {
    groupService.desactiveGroup(id)
      .then((res) => {
        
        Promise.all([
          dataGroups.dispatch('getGroups')
        ])

        if (res.data.success) {
          toast('Sucesso', res.data.success, 'success')
          // dataFighters.dispatch("setFightersCollect", res.data.fighters);
        }
      })
      .catch((err) => {
        toast('Aviso', err.response.data.error, 'error')
      })
  }
  storeApp.state.loading = false
}

function formatDate (date) {
  if (date !== null) {
    return moment(date).format('D/MM/Y')
  }

  return 'não informado'
}

function openModal (data) {
  dataGroups.dispatch('setModalActive', data)
}
</script>
